module.exports = __webpack_public_path__ + "static/img/access.97b705a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/access.png
// module id = 66
// module chunks = 1